







import { Vue, Component } from 'vue-property-decorator';
import { getRule } from '../api';
@Component
export default class Rule extends Vue {
  activeIndex = 0;
  content: string = '';
  async mounted() {
    const ret = await getRule();
    this.content = ret.data;
  }
}
